import React, { useState } from "react";
import Chart from "react-apexcharts";
import moment from "moment";
import { useEffect } from "react";

const LiveChart = ({ data, handleHideChart }) => {
  const [type] = useState({ id: "line" });
  const [yAnnotations, setYAnnotations] = useState([]);
  const options = {
    chart: { id: "data" },
    colors: ["#2ecc71", "#3498db", "#f1c40f", "#e74c3c", "#9b59b6"],
    stroke: {
      curve: "straight",
    },
    tooltip: { shared: true, theme: "dark", x: { show: false } },
    yaxis: {
      forceNiceScale: true,
      decimalsInFloat: 3,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      type: "datetime",
      tooltip: { formatter: (d) => moment(d).format("Do MMM ha") },
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    annotations: {
      yaxis: yAnnotations,
    },
  };

  useEffect(() => {
    const template = {
      y: null,
      borderColor: "#e74c3c",
      fillColor: "#e74c3c",
      label: {
        borderColor: "#e74c3c",
        style: {
          color: "#fff",
          background: "#e74c3c",
        },
        text: "",
      },
    };
    if (data.length !== 1) return setYAnnotations([]);
    const annotations = [];
    annotations.push({
      ...template,
      y: data[0].upperCheck,
      label: { ...template.label, text: "Upper Limit" },
    });
    annotations.push({
      ...template,
      y: data[0].lowerCheck,
      label: { ...template.label, text: "Lower Limit" },
    });
    setYAnnotations(annotations);
  }, [data]);

  function handleHide() {
    handleHideChart();
  }

  if (data.length === 0) return null;
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-auto">
          <button className="btn btn-primary mt-4" onClick={handleHide}>
            Hide Chart
          </button>
        </div>
      </div>
      <Chart options={options} series={data} type={type.id} height={400} />
    </React.Fragment>
  );
};

export default LiveChart;
